export const SET_INTERSTITIAL = 'SET_INTERSTITIAL'
